module.exports = __webpack_public_path__ + "static/media/om_faceshape_oval.78a2ce79.png";